// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase-price-cell {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  max-width: 100%;
  white-space: nowrap;
}

.purchase-price-cell__amount {
  font-size: 13px;
  line-height: 1;
}

.purchase-coupon-mark {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  padding: 3px 8px 3px 4px;
  border-radius: 7px;
  background: #fff6ee;
  border: 1px dashed #d85a2b;
  color: #c93312;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: help;
}

.purchase-coupon-mark__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #c93312;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0;
}

.purchase-date {
  margin: 0;
  font-size: 13px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/PurchaseCouponMark.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".purchase-price-cell {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  max-width: 100%;\n  white-space: nowrap;\n}\n\n.purchase-price-cell__amount {\n  font-size: 13px;\n  line-height: 1;\n}\n\n.purchase-coupon-mark {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n  padding: 3px 8px 3px 4px;\n  border-radius: 7px;\n  background: #fff6ee;\n  border: 1px dashed #d85a2b;\n  color: #c93312;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  line-height: 1;\n  text-transform: uppercase;\n  white-space: nowrap;\n  cursor: help;\n}\n\n.purchase-coupon-mark__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #c93312;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.purchase-date {\n  margin: 0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
